import 'inter-ui/inter.css'
import '@fontsource/ibm-plex-mono'

import { ChakraProvider } from '@chakra-ui/react'
import { QueryClientProvider } from '@tanstack/react-query'

import { theme } from '~/theme'

import { FlagProvider } from '~lib/feature-flag'
import { queryClient } from '~lib/react-query'

import { AppRouter } from './AppRouter'

const App = (): JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider portalZIndex={40} theme={theme} resetCSS>
        <FlagProvider>
          <AppRouter />
        </FlagProvider>
      </ChakraProvider>
    </QueryClientProvider>
  )
}

export default App
